// coreRoles is a list of role objects (with attributes 'id' and 'type') from Core API response
export const getRoles = (roles, coreRoles) => {
  const allRoles = [...roles.programRoles, ...roles.restrictedRoles, ...roles.systemRoles];
  return coreRoles.map((coreRole) => allRoles.find((role) => role.id === coreRole));
};
